// src/components/LandingPageShort.js
import React, { useState } from 'react';
import LpShortcuts from './LandingPageShortcuts';
import Signup from './Signup';

const LandingPageShort = () => {
  // State to control modal open/close
  const [showSignupModal, setShowSignupModal] = useState(false);

  // Opens the Signup modal
  const openSignupModal = () => {
    setShowSignupModal(true);
  };

  // Closes the Signup modal
  const closeSignupModal = () => {
    setShowSignupModal(false);
  };

  return (
    <div className="main-landing-page">
      <header>
        <div className="header-logo">
          <h1>Taskify</h1>
        </div>
      </header>

      <div className="shortcuts-landing-page-container">
        <section className="shortcuts-hero-section">
          <div className="shortcut-hero-content">
            Easily Access Your Favorite Sites. Select Your Shortcuts...
          </div>
        </section>

        <div className="shortcut-container">
          {/* Pass the openSignupModal function instead of navigating */}
          <LpShortcuts buyFreeTrial={openSignupModal} />
        </div>

        <section className="shortcuts-how-it-work">
          <div className="how-it-works-inner">
            <h2>How It Works</h2>
            <div className="how-it-works-inner-content">
              <div className="how-it-works-bullet-numbers">1</div>
              <div className="work-content-right">
                <h6>Select Shortcuts</h6>
                <p>Pick your favorite shortcuts to socials, emails, websites, and more!</p>
              </div>
            </div>
            <div className="how-it-works-inner-content">
              <div className="how-it-works-bullet-numbers">2</div>
              <div className="work-content-right">
                <h6>Create Account</h6>
                <p>Create your account to access shortcuts and unlimited AI chat with a free 7-day trial, completely risk-free.</p>
              </div>
            </div>
            <div className="how-it-works-inner-content">
              <div className="how-it-works-bullet-numbers">3</div>
              <div className="work-content-right">
                <h6>Get Unlimited Chat Help Online</h6>
                <p>With the help of your AI Tech Expert, you can get almost any question answered instantly. 24/7 help and unlimited questions, so you never have to go it alone online.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="pricing-area-outer">
          <div className="pricing-area-inner">
            <h2>Free 7-Day Trial, Then Only $20/month. No commitments.</h2>
            <p>Unlock unlimited AI chat with your tech expert for just $20 per month, cancel anytime.</p>
          </div>
        </section>
      </div>

      {/* Conditionally render the Signup modal */}
      {showSignupModal && (
        <div className="modal-overlay" onClick={closeSignupModal}>
          {/* Stop click from bubbling so clicking inside doesn't close modal */}
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeSignupModal}>
              X
            </button>
            <Signup />
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPageShort;
